import { atom } from "recoil";

export const videoListState = atom({
  key: "videoListState",
  default: [],
});
